import { atom, useAtomValue } from 'jotai'
import { store } from './general'

const loadingAtom = atom(false)

export const setLoading = (isLoading: boolean) => {
  store.set(loadingAtom, isLoading)
}

export const useLoading = () => {
  return useAtomValue(loadingAtom)
}

export default loadingAtom
